import TableHead from "./Table/TableHead";
import useTable from "./Provider/useTable";
import TableRow from "./Table/TableRow";

import { Table, TBody } from "../components";

import { useNavigate } from "react-router-dom";
import TableContext from "./Provider/TableContext";
import ApproveModal from "./Table/ApproveModal";
import CancelModal from "./Table/CancelModal";
import DeleteModal from "./Table/DeleteModal";

function Shipments() {
  const {
    limit,
    setLimit,
    docs,
    setDocs,
    isLoading,
    setIsLoading,
    isFiltered,
    setIsFiltered,
    pagination,
    setOrder,
    clearFilters,
    refetchDocs,
    shipmentId,
    setShipmentId,
    showDeleteModal,
    setShowDeleteModal,
    showApproveModal,
    setShowApproveModal,
    showCancelModal,
    setShowCancelModal,
    handleDelete,
    handleApprove,
    handleCancel,
  } = useTable();

  const navigate = useNavigate();

  return (
    <>
      <TableContext.Provider
        value={{
          limit,
          setLimit,
          docs,
          setDocs,
          isLoading,
          setIsLoading,
          isFiltered,
          setIsFiltered,
          pagination,
          setOrder,
          clearFilters,
          refetchDocs,
          shipmentId,
          setShipmentId,
          showDeleteModal,
          setShowDeleteModal,
          showApproveModal,
          setShowApproveModal,
          showCancelModal,
          setShowCancelModal,
          handleDelete,
          handleApprove,
          handleCancel,
        }}
      >
        <Table
          label="Shipments"
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setDocs={setDocs}
          isFiltered={isFiltered}
          handleAdd={() => navigate("add")}
          setIsFiltered={setIsFiltered}
          handleRemoveFilters={clearFilters}
          pagination={pagination}
          url="shipments/search"
        >
          <TableHead setOrder={setOrder} />
          <TBody>
            {docs.map((doc, i) => (
              <TableRow key={doc?.id || i} doc={doc} />
            ))}
          </TBody>
        </Table>
      </TableContext.Provider>

      {showDeleteModal && (
        <DeleteModal
          showDeleteModal={showDeleteModal}
          setShowDeleteModal={setShowDeleteModal}
          handleDelete={handleDelete}
        />
      )}

      {showApproveModal && (
        <ApproveModal
          showApproveModal={showApproveModal}
          setShowApproveModal={setShowApproveModal}
          handleApprove={handleApprove}
        />
      )}

      {showCancelModal && (
        <CancelModal
          showCancelModal={showCancelModal}
          setShowCancelModal={setShowCancelModal}
          handleCancel={handleCancel}
        />
      )}
    </>
  );
}

export default Shipments;
